<h2 mat-dialog-title>
  {{ 'MEETING_SCHEDULER.MEETING_LIST.SALES_TEAM_DIALOG.TITLE' | translate }}
</h2>

<mat-dialog-content>
  <form [formGroup]="form">
    <glxy-form-field prefixIcon="search">
      <input
        type="text"
        matInput
        formControlName="team"
        [matAutocomplete]="salesTeamName"
        placeholder="{{ 'MEETING_SCHEDULER.MEETING_LIST.SALES_TEAM_DIALOG.PLACEHOLDER' | translate }}"
        [matAutocompleteDisabled]="matAutocompleteDisabled"
        (click)="onInputClick()"
      />
      <mat-autocomplete #salesTeamName="matAutocomplete" [displayWith]="displayTeamName">
        @for (calendar of filteredTeams$ | async; track calendar.id ?? $index) {
          <mat-option [value]="calendar">{{ calendar.displayName }}</mat-option>
        }
      </mat-autocomplete>
    </glxy-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>
    {{ 'MEETING_SCHEDULER.MEETING_LIST.SALES_TEAM_DIALOG.CLOSE' | translate }}
  </button>

  <button mat-flat-button color="primary" (click)="createEvent()">
    <glxy-button-loading-indicator [isLoading]="isLoading">
      {{ 'MEETING_SCHEDULER.MEETING_LIST.SALES_TEAM_DIALOG.CREATE_EVENT_TYPE' | translate }}
    </glxy-button-loading-indicator>
  </button>
</mat-dialog-actions>
